import { Accordion } from '@verndale/front-end-components';

// eslint-disable-next-line
const _uuid = require("uuid");

class Module extends Accordion {

    initAccordion() {
        this.dom.items.forEach(item => {
          const guid = (0, _uuid.v4)();
          const trigger = item.querySelector('.accordion__item-trigger');
          const content = item.querySelector('.accordion__item-panel');

          if (trigger.getAttribute('aria-expanded') === 'true') {
            content.style.height = `auto`;
            content.style.visibility = 'visible';
          }

          trigger.setAttribute('aria-controls', `tabcontent-${guid}`);
          trigger.setAttribute('id', `tab-${guid}`);
          content.setAttribute('aria-labelledby', `tab-${guid}`);
          content.setAttribute('id', `tabcontent-${guid}`);
        });
      }
}

export default Module;
